import { Stack, Typography } from "@altimateai/lego";

export const StatMetric = ({ label, value, id }: { label: string; value: number; id: string }) => (
  <Stack gap="md" direction="column" className="al-flex-1">
    <Typography variant="h4" className="al-text-2xl" aria-label={`${label} value: ${value}`}>
      {value}
    </Typography>
    <Typography variant="caption" className="al-text-gray-500" id={`${id}-label`}>
      {label}
    </Typography>
  </Stack>
);
